import { formatBytes, getFileType } from "utils/file";
import { Dwg, PictureAsPdf, UploadViewWrapper } from "components/UploadView/uploadView.styles";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { ReplacementFile } from "features/reducers/replacementOrder/cart.ts";

export interface Props {
	index: number;
	file: ReplacementFile;
	onImageRemove: (index: number) => void;
}

const UploadView = ({ index, file, onImageRemove }: Props) => {
	const getThumbnail = (file: ReplacementFile) => {
		const fileType = getFileType(file.name);
		if (fileType === "pdf") return <PictureAsPdf />;
		if (fileType === "dwg") return <Dwg />;
		return (
			<img
				src={file.fileUrl}
				alt="uploaded file"
			/>
		);
	};

	return (
		<UploadViewWrapper
			key={index}
			data-testid="upload-file-view"
		>
			<div>
				{getThumbnail(file)}
				<div>
					<p>{file.name}</p>
					<p>{formatBytes(file.size)}</p>
				</div>
			</div>
			<button
				onClick={() => onImageRemove(index)}
				data-testid="upload-file-view-remove-button"
			>
				<CloseOutlined />
			</button>
		</UploadViewWrapper>
	);
};
export default UploadView;
